var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shelter-areas-archived"},[_c('main-section-shelter-areas-archived')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }